import { useEffect, useMemo, useState } from 'react';

import { EventCard } from '../../../../components/EventCard/EventCard';
import { Loader } from '../../../../components/Loader/Loader';
import { axiosInstance } from '../../../../helpers/axios';
import { useAppSelector } from '../../../../hooks/reduxHooks/useAppSelector';
import { IEventCard, Role } from '../../../../types/types';
import Pagination from '../../../StaffPages/SupportList/Pagination';
import styles from './ParticipateEvents.module.scss';

export const ParticipateEvents = () => {
    const [events, setEvents] = useState<IEventCard[] | null>(null); // стэйт с новостями

    //пагинация
    const [page, setPage] = useState<number>(1); // стэйт - текущая страница в пагинации
    const [paginationArr, setPaginationArr] = useState<number>(1); // максимальное количество страниц

    //индикатор загрузки
    const [isLoading, setIsLoading] = useState<boolean>(false); //изначально нет загрузки

    const { id, role } = useAppSelector((state) => state.authReducer);

    const eventsUrl = useMemo(() => {
        if (role === Role.staff) {
            return `/v1/staff/${id}/event/?page=${page}&size=10`;
        }
        if (role === Role.organization) {
            return `/v1/company/${id}/event/?page=${page}&size=10`;
        }
        return `/v1/candidate/${id}/event/?page=${page}&size=10`;
    }, [id, page, role]);

    useEffect(() => {
        setIsLoading(true); // загрузка началась
        axiosInstance
            .get(eventsUrl)
            .then((response) => {
                const pagArray = response.data.page_count;
                setPaginationArr(pagArray); // массив булетов для отрисовки
                setEvents(response.data.objects); // данные по карточкам
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => setIsLoading(false)); // загрузка закончена
    }, [eventsUrl]);

    return (
        <div className={styles.ParticipateEvents}>
            {isLoading ? (
                <div className={styles.ParticipateEvents__loader}>
                    <Loader />
                </div>
            ) : (
                <div className={styles.ParticipateEvents__wrapper}>
                    <div className={styles.ParticipateEvents__cards}>
                        {events && events.length > 0 ? (
                            <ParticipateEventsList events={events} />
                        ) : (
                            <p className={styles.ParticipateEvents__text}>
                                Вы еще не участвуете в мероприятиях
                            </p>
                        )}
                    </div>
                </div>
            )}
            <Pagination
                list={{
                    page_count: paginationArr,
                    current_page: page,
                }}
                handlePagination={(p) => {
                    setPage(p);
                }}
                isLoading={isLoading}
            />
        </div>
    );
};

interface ParticipateEventsListProps {
    events: IEventCard[];
}

const ParticipateEventsList = ({ events }: ParticipateEventsListProps) => {
    return (
        <div className={styles.FavouritesList}>
            {events.map((event) => (
                <EventCard
                    event={event}
                    key={event.id}
                    containerClassName={styles.personalPage}
                    imageClassName={styles.personalPage__image}
                    titleClassName={styles.personalPage__title}
                    smallBlocksClassName={styles.personalPage__smallBlocks}
                />
            ))}
        </div>
    );
};
